import comp from "./PusherConsumer";
export default comp;
